
import baseURL from "../common/axios";
class SupplierContactDetailsService {
    insert(objinsert) {
        debugger;
        return baseURL.httpMSInventoryUrl.post("SupplierContactDetails/Create", objinsert);
    }
    getdata() {
        debugger;
        return baseURL.httpMSInventoryUrl.get("SupplierContactDetails/List");
    }
    Edit(EditID) {
        debugger;
        return baseURL.httpMSInventoryUrl.get(
            "SupplierContactDetails/Get?id=" + EditID + ""
        );
    }
    Delete(DelID) {
        debugger;
        return baseURL.httpMSInventoryUrl.delete(
            "SupplierContactDetails/Delete?id=" + DelID
        );
    }
    //Active
    active(DelID, Status) {
        debugger;
        return baseURL.httpMSInventoryUrl.put(
            "SupplierContactDetails/Active?id=" + DelID + "&Status=" + Status + ""
        );
    }
    Update(objupdate) {
        debugger;
        return baseURL.httpMSInventoryUrl.post("SupplierContactDetails/Update", objupdate);
    }

    //FileInsert
    Fileinsert(objinsert) {
        debugger;
        return baseURL.httpMSInventoryUrl.post(
            "ManufactureImagesMAS/Create",
            objinsert
        );
    }

    //Get Files by Manufacture Id
    GetFilesByManufactureId(ManufactureId) {
        debugger;
        return baseURL.httpMSInventoryUrl.get(
            "ManufactureImagesMAS/ListManufactureImagesMASBySupplierContactDetailsId?ManufactureId=" +
            ManufactureId +
            ""
        );
    }
}
export default new SupplierContactDetailsService();
